
import React from 'react';

const ThankYou = () => {
  return (
    <div className="thankyou-page">
      <h1>Thank You!</h1>
      <p>Your application has been successfully submitted.</p>
      <p>We appreciate your interest in joining our team and will get back to you soon.</p>
    </div>
  );
};

export default ThankYou;
